import React, { useState, useEffect } from "react" ;

import { getDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { getChildResources } from "root/DataFunctions/ChildDataFns";

import ResourceCard from "../Components/UI/ResourceCard";
import Loading from "../Components/Loading";

import "../styles/Pages/learning.scss";

const Learning = () => {
    const [learnings, setLearnings] = useState("");

    useEffect(() => {
        getChildResources(2, (response) =>
        {
            setLearnings(getDataFromResponse(response));
        });
    }, []);
    return (
        <div style={{flex: "1"}}>
            <div className="child_breadcrumb child_breadcrumb-main">
                <div className="child_breadcrumb_inner">
                    <h2 className="child_breadcrumb_title">
                        Learning
                    </h2>
                </div>
            </div>
            <div className="article-container">
                {learnings 
                    ? learnings.map((learning) =>
                        <ResourceCard 
                            key={learning.resource_id} 
                            icon_id={learning.icon_id}
                            link={learning.link}
                            document_id={learning.document_id}
                            name={learning.name}
                            description={learning.description}
                        />
                    ) 
                    : <Loading />
                }
            </div>
        </div>
    );
}

export default Learning;
